
































import { Component, Vue, Prop } from "vue-property-decorator";
import { LicenseModel } from "../models";

interface ListItem {
  title: string;
  subtitle: string;
  value: string;
  icon: string;
  index: number;
}

@Component
export default class Stats extends Vue {
  @Prop({ required: true })
  license!: LicenseModel;

  @Prop({ default: false })
  link!: boolean;

  get items(): ListItem[] {
    const ts = +new Date();

    const items = [
      {
        title: `Licentie`,
        subtitle: `Enkel CRM, of het beste uit je data halen?`,
        value: this.license.bundleName,
        icon: `laptop`,
        index: ts
      },
      {
        title: `Aantal gebruikers`,
        subtitle: `Het aantal gebruikers dat gelijktijdig Compenda mag gebruiken`,
        value: String(this.license.no_of_users),
        icon: `user-friends`,
        index: ts
      },
      {
        title: `Mobiele app`,
        subtitle: `Ook onderweg inzicht in jouw data`,
        value: this.license.app ? `In gebruik` : `Niet in gebruik`,
        icon: `mobile`,
        index: ts
      },
      {
        title: `Mobiele app gebruikers`,
        subtitle: `Het totale aantal mobiele app gebruikers`,
        value: String(this.license.no_of_app_users),
        icon: `user-friends`,
        index: ts
      }
    ];

    if (this.license.cloud) {
      items.push({
        title: `Compenda Cloud`,
        subtitle: `Je database veilig en vertrouwd bij ons in de Compenda Cloud™`,
        value: `Ja`,
        icon: `cloud`,
        index: ts
      });
    }

    if (this.license.soap) {
      items.push({
        title: `Compenda Maatwerk`,
        subtitle: `Uitbreidingen op maat`,
        value: `Je gebruikt maatwerk`,
        icon: `hammer`,
        index: ts
      });
    }

    return items;
  }
}
